import Log from '../common/log';
export default class DiagnosticTool {
    constructor() { }
    static getInstance(forceNew = false) {
        if (!this._instance || forceNew) {
            this._instance = new DiagnosticTool();
        }
        return this._instance;
    }
    showUnsupportedWarning() {
        if (!DiagnosticTool.warningShown) {
            Log.notice('DiagnosticTool', ' DiagnosticTools is not supported in this build version.');
            DiagnosticTool.warningShown = true;
        }
    }
    /**
     * @internal
     */
    destroy() {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     */
    start(npawPluginInstance) {
        this.showUnsupportedWarning();
    }
    setSettings(newConfig) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     */
    clearReportTimeout() {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param options
     */
    setOptions(options) {
        this.showUnsupportedWarning();
    }
    setBalancerEnabled(enabled) {
        this.showUnsupportedWarning();
    }
    setVideoAnalyticsEnabled(enabled) {
        this.showUnsupportedWarning();
    }
    setAdsAnalyticsEnabled(enabled) {
        this.showUnsupportedWarning();
    }
    getReportTimeout() {
        this.showUnsupportedWarning();
        return DiagnosticTool.defaultReportTimeout;
    }
    setReportTimeout(timeout) {
        this.showUnsupportedWarning();
    }
    // Balancer Diagnostic methods
    /**
     * @internal
     */
    cleanCdnList() {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param name
     * @param cdn
     */
    addCdn(name, cdn) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param name
     * @param numberOfRequests
     * @param trafficServedInBytes
     * @param failedRequests
     */
    updateCdnInfo(name, numberOfRequests, trafficServedInBytes, failedRequests) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param wasSuccessful
     * @param errorMessage
     */
    wasSelectorCommunicationSuccessful(wasSuccessful, errorMessage) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param intercepted
     */
    setInterceptedRequests(intercepted) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param enabled
     */
    setActiveSwitchingEnabled(enabled) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param performed
     */
    wasActiveSwitchingDecisionPerformed(performed) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param switched
     */
    setSwitchedCdns(switched) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param used
     */
    usedSelectorAPIResponse(used) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param tried
     */
    setTriedSendingBalancerStats(tried) {
        this.showUnsupportedWarning();
    }
    // Video Analytics Diagnostic methods
    /**
     * @internal
     * @param requestPath
     */
    addNQSRequest(requestPath) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param eventType
     * @param params
     */
    addNQSEvent(eventType, params) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param registered
     */
    registeredPlayer(registered) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param tried
     */
    setTriedSendingNQSStats(tried) {
        this.showUnsupportedWarning();
    }
    // Ad Analytics methods
    /**
     * @internal
     * @param requestPath
     */
    addNQSAdRequest(requestPath) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param eventType
     * @param params
     */
    addNQSAdEvent(eventType, params) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param registered
     */
    registeredAdsPlayer(registered) {
        this.showUnsupportedWarning();
    }
    /**
     * @internal
     * @param tried
     */
    setTriedSendingNQSAdStats(tried) {
        this.showUnsupportedWarning();
    }
    report() {
        this.showUnsupportedWarning();
    }
}
DiagnosticTool.defaultReportTimeout = 5 * 60 * 1000; // 5 minutes
DiagnosticTool.warningShown = false;
